import type {ControladorRedaccionUltimas} from "../ctrl";
import {ESelector} from "../data/auxiliares";
import type {IModuloBase} from "../../../../root/modulo";
import {ModuloRedaccionUltimas} from "./";

export class ModuloRedaccionUltimasNews extends ModuloRedaccionUltimas {
    /* STATIC */
    public static buildArticulo(cfg: IModuloBase): ModuloRedaccionUltimasNews[] {
        return [
            new this({
                ...cfg,
                id: "redaccion.ultimas.articulo",
                selector:  ESelector.NOTICIAS_DESARROLLO,
                promocionados: true,
            }),
        ];
    }

    public static buildGeneral(cfg: IModuloBase): ModuloRedaccionUltimasNews[] {
        const id = "redaccion.ultimas.general";
        return [
            new this({
                ...cfg,
                id,
                selector: ESelector.NOTICIAS_DIRECTORIO,
                promocionados: true,
            }),
            new this({
                ...cfg,
                id,
                selector: ESelector.NOTICIAS_HOME,
                promocionados: true,
            }),
        ];
    }

    public static buildLocalidad(cfg: IModuloBase): ModuloRedaccionUltimasNews[] {
        const id = "redaccion.ultimas.localidad";
        return [
            new this({
                ...cfg,
                id,
                selector: ESelector.NOTICIAS_LOCALIDAD,
                promocionados: false,
            }),
        ];
    }

    /* INSTANCE */
    protected async controller(element: Element): Promise<ControladorRedaccionUltimas> {
        const {ControladorRedaccionUltimaNews} = await import(/* webpackChunkName: "module/redaccion/last/ctrl/news" */ "../ctrl/news");

        return new ControladorRedaccionUltimaNews({cfg: this.cfg.global, dominio: this.cfg.dominio, element, selector: this.cfg.selector as ESelector, promocionados: this.cfg.promocionados});
    }
}

export default ModuloRedaccionUltimasNews;
